import VisionSource from '@screens/vision/source'

export default function VisionSourcePage() {
  return <VisionSource />
}
